__turbopack_context__.v({
  "clickable-part": "IngridLogo-module-scss-module__mi8qQq__clickable-part",
  "logo": "IngridLogo-module-scss-module__mi8qQq__logo",
  "logo-wrapper": "IngridLogo-module-scss-module__mi8qQq__logo-wrapper",
});
